import React from "react";
import * as hs from "@hlibs/react/hstyles";
import { Footer } from "@hlibs/react-web/layouts";

const Component = () => {
  return (
    <Footer
      minHeight={63}
      paddingLeftRightFlex={0.2}
      containerStyles={[
        hs.size.fillParentWidth(),
        hs.flexLayout.horizontal(),
        hs.padding.leftRightAll(20),
        hs.padding.bottom(80),
      ]}
    ></Footer>
  );
};

export default Component;
